import { callAPI } from "../config/AxiosTemplate";

import { API_RESPONSE_STATUS_CODES, API } from "../Utils/Constants";
import {
  SAVE_USER_DETAILS,
  CLEAR_USER_DETAILS,
  SAVE_USER_ROLES,
} from "./Constants";

import {
  DEFAULT_PAGINATION_RECORDS_COUNT,
  DEFAULT_PAGINATION_ACTIVE_PAGE,
} from "../CustomUIComponents/Pagination/PaginationConstants";

export const getUsersBySearchFilterAction = (searchFilterObject, callback) => {
  let data = {
    filter: {
      role: searchFilterObject.filterRole
        ? searchFilterObject.filterRole
        : undefined,
    },
    search: {
      username: searchFilterObject.searchUsername
        ? searchFilterObject.searchUsername
        : undefined,
    },
    limit: searchFilterObject.limit
      ? searchFilterObject.limit
      : DEFAULT_PAGINATION_RECORDS_COUNT,
    offset: searchFilterObject.offset
      ? searchFilterObject.offset - 1
      : DEFAULT_PAGINATION_ACTIVE_PAGE - 1,
  };
  callAPI(
    "getUsersBySearchFilter",
    API.getUsersBySearchFilter,
    "POST",
    data,
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    }
  );
};

export const getUserRolesAction = (callback) => (dispatch) => {
  let data = {
    limit: 1000,
    offset: 0,
  };
  callAPI("getUserRoles", API.getUserRoles, "POST", data, (apiResponse) => {
    if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
      dispatch({
        type: SAVE_USER_ROLES,
        data: apiResponse.data.data.data.roles,
      });
      callback(apiResponse.data.data);
    } else {
      callback(null);
    }
  });
};

export function saveUserDetailsAction(userDetails) {
  if (userDetails && userDetails.role && userDetails.role.role) {
    userDetails.role = userDetails.role.role;
  }
  return function (dispatch) {
    dispatch({
      type: SAVE_USER_DETAILS,
      userDetails: userDetails,
    });
  };
}

export function clearUserDetailsAction() {
  return function (dispatch) {
    dispatch({
      type: CLEAR_USER_DETAILS,
    });
  };
}
